module.exports = __webpack_public_path__ + "img/서비스건강노화.2da6ccf4.png";